import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { supabase } from "@/integrations/supabase/client";
import { analytics } from "@/lib/analytics";
import { useT } from "@/i18n";

export function WaitlistForm({ product, cta }: { product: string; cta?: string }) {
  const { t } = useT();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  return (
    <form
      className="mx-auto mt-8 flex max-w-md gap-2"
      onSubmit={async (e) => {
        e.preventDefault();
        if (!email.trim()) return;
        setBusy(true);
        try {
          const { error } = await supabase
            .from("waitlist_signups")
            .insert({ email: email.trim().toLowerCase(), product });
          if (error) throw error;
          analytics.lead({ source: "waitlist", detail: product });
          toast.success(t("shell.waitlist.success"));
          setEmail("");
        } catch (err) {
          toast.error(err instanceof Error ? err.message : t("shell.waitlist.error"));
        } finally {
          setBusy(false);
        }
      }}
    >
      <Input
        type="email"
        required
        placeholder={t("shell.waitlist.emailPlaceholder")}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <Button type="submit" variant="hot" disabled={busy}>
        {busy ? t("shell.waitlist.adding") : cta ?? t("shell.waitlist.notifyMe")}
      </Button>
    </form>
  );
}
